// Show avatars which are clickable and show the user's profile
import { IonCard, IonCardContent } from "@ionic/react";
import React from "react";
import { DashBoardComponentProps } from "../data/data";
import MeasurmentResult from "../../../components/MeasurementsResults";
import { currentConfig } from "../../../common/domainConfig";
import { Loading } from "./Loading";

export const AvatarTab: React.FC<DashBoardComponentProps> = ({
  objectModels,
  clientData,
}) => {
  const visibleMeasurements =
    (clientData.gender === "female"
      ? currentConfig.measurements.female
      : currentConfig.measurements.male).filter(
      (m) => m.key !== "weight" && m.key !== "body_fat"
    ) || [];

  return (
    <IonCard className="p-0 m-0 ">
      <IonCardContent className="p-0 overflow-y-scroll">
        {(objectModels.length && clientData) ? (
          <MeasurmentResult
            visibleMeasurements={visibleMeasurements}
            objectModels={objectModels}
            //measurementList={objectModels.map((o) => o.measurements)}
          />
        ):<Loading></Loading>}
      </IonCardContent>
    </IonCard>
  );
};
